module.exports = __webpack_public_path__ + "img/icon_flag_us@3x.cd8444ab.png";